import { render, staticRenderFns } from "./ProductsCarousel.vue?vue&type=template&id=4ba8cb7e&scoped=true"
import script from "./ProductsCarousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductsCarousel.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProductsCarousel.vue?vue&type=style&index=0&id=4ba8cb7e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba8cb7e",
  null
  
)

export default component.exports